import * as React from 'react';
import { LocalForm, Control, Form, actions, Errors } from 'react-redux-form';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { renderMultilineTextField, renderDateTimeEdit, renderSelect, renderErrorInfoText } from '../../common/forms/FieldCreators';
import { localizations } from '../../localization/localization';
import FormItem from '../../components/forms/FormItem';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { NotificationModel } from '../../common/models/CommonModels';
import * as validators from '../../common/validators/formValidators'

interface DialogProps {
    open: boolean;
}

interface EditActions {
    onSubmit: (notification: any) => void;
    onCancel: () => void;
}

type AddNotificationFormProps = EditActions & DialogProps;


const AddNotificationForm = (props: AddNotificationFormProps) => {
    const addNotificationModel: NotificationModel = {
        message: "",
        validFrom: null,
        validTo: null,
        redirectTo: ""
    };

    const redirectionOptions = [
        { label: localizations.menus.frontPage, value: "/" },
        { label: localizations.menus.freeUnits, value: "/freeunits" },
        { label: localizations.menus.freeTrucks, value: "/freetrucks" },
        { label: localizations.settings.settingsTitle, value: "/settings" },
        { label: localizations.statistics.statistics, value: "/statistics" },
        { label: localizations.menus.instructions, value: "/help" },
        { label: localizations.menus.termsOfService, value: "/terms" },
        { label: localizations.menus.privacyPolicy, value: "/privacy" }
    ];

    return (
        <Dialog open={props.open} fullWidth>
            <LocalForm 
                onSubmit={(notification) => props.onSubmit(notification)} 
                model={"notification"} 
                initialState={addNotificationModel}
            >
                <DialogTitle style={{ textAlign: "center" }}>
                    <Typography variant="h4" paragraph>{localizations.notifications.addNotification}</Typography>
                </DialogTitle>
                <DialogContent>
                    <FormItem>
                        <Control.text 
                            model=".message" 
                            validators={{required: validators.required }} 
                            component={renderMultilineTextField} 
                            label={localizations.notifications.notification}
                            controlProps={{rows: 5}}
                        />
                        <Errors
                            model=".message"
                            messages={{
                                required: localizations.validation.required
                            }}
                            show={{touched: true, focus: false }}
                            wrapper={renderErrorInfoText}
                        />
                    </FormItem>
                    <FormItem>
                        <Control.text model=".validFrom" component={renderDateTimeEdit} label={localizations.common.startTime} controlProps={{clearable: true}} />
                    </FormItem>
                    <FormItem>
                        <Control.text model=".validTo" component={renderDateTimeEdit} label={localizations.common.endTime} controlProps={{clearable: true}} />
                    </FormItem>
                    <FormItem>
                        <InputLabel key="reason-select">{localizations.notifications.redirectUsersTo}</InputLabel>
                        <Control.select 
                            model=".redirectTo" 
                            component={renderSelect} 
                            id="redirectTo-select" 
                        >
                            <MenuItem key={"noRedirection"} value={""}/>
                            {redirectionOptions.map((opt: any) => <MenuItem key={opt.label} value={opt.value}>{opt.label}</MenuItem>)}
                        </Control.select>
                    </FormItem>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={props.onCancel}>{localizations.actions.cancel}</Button>
                    <Button variant="contained" color="secondary" type="submit">{localizations.actions.ok}</Button>
                </DialogActions>
            </LocalForm>
        </Dialog>
    );
}

export default AddNotificationForm;


// WEBPACK FOOTER //
// ./src/admin/companies/AddNotificationForm.tsx